import {
  useMemo,
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  FilterBoxProps,
  filterSelectionsType,
} from "../../../interfaces/queryBuilderInterfaces";
import { Dropdown } from "../../../components/dropdown/Dropdown";
import Checkbox from "../../../components/checkbox/Checkbox";

export interface FilterConditionProp {
  type: string;
  value: string;
  exclude: boolean;
}

interface FilterConditionProps {
  condition: FilterConditionProp;
  setConditions?: (conditions: FilterConditionProp) => void;
}

export interface FilterConditionRef {
  clearConditions: () => void;
}

const FilterCondition = forwardRef<FilterConditionRef, FilterConditionProps>(
  ({ condition, setConditions }, ref) => {
    const conditionKeys = {
      Contains: "Contains",
      StartsWith: "StartsWith",
      EndsWith: "EndsWith",
      Exact: "Exact",
      "Freeform (? = Any Character, * = Any String)": "Freeform",
    };

    const [selectedCondition, setSelectedCondition] = useState<string | null>(
      (condition && condition.type) || null,
    );
    const [selectedValue, setSelectedValue] = useState<string | null>(
      (condition && condition.value) || null,
    );
    const [isExclude, setIsExclude] = useState<boolean>(
      (condition && condition.exclude) || false,
    );
    const conditionOptions = useMemo(() => {
      return (
        Object.keys(conditionKeys) as Array<keyof typeof conditionKeys>
      ).map((item) => ({
        value: conditionKeys[item],
        label: item,
      }));
    }, []);

    const handleConditionChange = (value: string) => {
      setSelectedCondition(value);
      setConditions &&
        setConditions({
          type: value,
          value: selectedValue || "",
          exclude: isExclude,
        });
    };

    const handleValueChange = (value: string) => {
      setSelectedValue(value);
      setConditions &&
        setConditions({
          type: selectedCondition || "Contains",
          value: value || "",
          exclude: isExclude,
        });
    };

    const clearConditions = () => {
      setSelectedValue("");
    };

    useImperativeHandle(ref, () => ({
      clearConditions,
    }));

    return (
      <div className="filter-dialog-container dialog-box-min filter-box">
        <div className="dialog-body nopadding">
          <div className="condition-row">
            <Dropdown
              id={"condition-dropdown"}
              label="Condition Type"
              selectedValue={selectedCondition || ""}
              onChange={handleConditionChange}
              options={conditionOptions}
            />

            <div className="condition-input">
              <label htmlFor="condition-value" style={{ fontWeight: "bold" }}>
                Value
              </label>
              <input
                id="condition-value"
                className="input-field"
                type="text"
                onChange={(e) => handleValueChange(e.target.value)}
                value={selectedValue ?? ""}
              />
            </div>
          </div>
          <div style={{ float: "right" }}>
            <label
              className="radio-inline"
              htmlFor="excluded-checkbox"
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <Checkbox
                id="excluded-checkbox"
                name="exclude"
                checked={isExclude}
                onChange={() => {
                  setIsExclude(!isExclude);
                  setConditions &&
                    setConditions({
                      type: selectedCondition || "Contains",
                      value: selectedValue || "",
                      exclude: !isExclude,
                    });
                }}
                value={""}
                styleClass={""}
                color={""}
              />
              <span style={{ marginLeft: "5px" }}>Exclude</span>
            </label>
          </div>
        </div>
      </div>
    );
  },
);

FilterCondition.displayName = "FilterCondition";

export default FilterCondition;
